module.exports = __webpack_public_path__ + "img/c12.12d10633.png";